export type NavItem = "Library" | "Settings" | "Help";

export function NavigationView({ selected, onSelect }: { selected: NavItem | null; onSelect: (n: NavItem) => void }) {
  const cls = (n: NavItem, extra: string) => `${extra} item${selected === n ? " selectedNav" : ""}`;
  return (
    <div className="NavigationView">
      <ul>
        <li id="LibraryItem" className={cls("Library", "libraryItem")} onClick={() => onSelect("Library")}>
          Gear Library
        </li>
        <li id="SettingsItem" className={cls("Settings", "settingsItem")} onClick={() => onSelect("Settings")}>
          Settings
        </li>
        <li id="HelpItem" className={cls("Help", "helpItem")} onClick={() => onSelect("Help")}>
          Help
        </li>
      </ul>
    </div>
  );
}
